export class DocumentExtractionSessionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentExtractionRequests() {
    return this.#http.get(`/api/document-extraction-requests/current-user-session`);
  }

  async updateDocumentExtractionRequest(body) {
    return this.#http.put(
      `/api/documents/${body.documentId}/extraction-request/sessions/${body.sessionId}`,
      body,
    );
  }

  async overrideDocumentExtractionRequest(body) {
    return this.#http.put(`/api/documents/${body.documentId}/extraction-request/override`, body);
  }
}
